import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-serif font-semibold tracking-wide transition-all duration-300 rounded-sm';
  const variants = {
    primary: 'bg-gold-500 text-navy-900 hover:bg-gold-400 shadow-[0_0_15px_rgba(201,163,92,0.3)] hover:shadow-[0_0_25px_rgba(201,163,92,0.5)] border border-gold-400/50',
    outline: 'border-2 border-gold-500 text-gold-500 hover:bg-gold-500/10',
    ghost: 'text-gold-500 hover:bg-gold-500/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-292">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';